export enum ProductStockStatus {
  OUT_OF_STOCK = 'outofstock',
  IN_STOCK = 'instock',
  ON_BACKORDER = 'onbackorder',
}

export enum ProductBackorderStatus {
  DO_NOT_ALLOW = 'no',
  ALLOW_NOTIFY = 'notify',
  ALLOW = 'yes',
}

export enum ProductTypes {
  SIMPLE = 'simple',
  GROUPED = 'grouped',
  EXTERNAL = 'external',
  VARIABLE = 'variable',
}

export enum ProductVariantStatus {
  DRAFT = 'draft',
  PENDING = 'pending',
  PRIVATE = 'private',
  PUBLISH = 'publish'
}


export enum EcommerceAnalyticsLabel {
  CREATE = 'Create',
  EDIT = 'Edit',
  DELETE = 'Delete',
  CHANGE_STATUS = 'Change status',
  VIEW = 'View'
}
